import React, { useMemo } from 'react';
import { CalendarProvider } from '@wix/ai-scheduling-assistant-common-lib/commonTypes';
import AppleCalendarLogo from '../assets/appleCalendarLogo.svg';
import GoogleLogo from '../assets/googleLogo.svg';
import OutlookLogo from '../assets/outlookLogo.svg';
import { CalendarProviderData } from '../components/ConnectCalendarModal/types';
import { useUouLanguage } from './useUouLanguage';

export const useCalendarProviderData = ({ iconSize }: { iconSize: number } = { iconSize: 24 }) => {
  const language = useUouLanguage();

  const calendarProviderData: Record<CalendarProvider, CalendarProviderData> = useMemo(
    () => ({
      [CalendarProvider.GOOGLE]: {
        provider: CalendarProvider.GOOGLE,
        logo: <GoogleLogo height={iconSize} width={iconSize} />,
        title: language.ASA_STANDALONE_CALENDAR_PROVIDER_GOOGLE_TITLE(),
        subtitle: language.ASA_STANDALONE_CALENDAR_PROVIDER_GOOGLE_SUBTITLE(),
      },
      [CalendarProvider.MICROSOFT]: {
        provider: CalendarProvider.MICROSOFT,
        logo: <OutlookLogo height={iconSize} width={iconSize} />,
        title: language.ASA_STANDALONE_CALENDAR_PROVIDER_MICROSOFT_TITLE(),
        subtitle: language.ASA_STANDALONE_CALENDAR_PROVIDER_MICROSOFT_SUBTITLE(),
      },
      [CalendarProvider.ICLOUD]: {
        provider: CalendarProvider.ICLOUD,
        logo: <AppleCalendarLogo height={iconSize} width={iconSize} />,
        title: language.ASA_STANDALONE_CALENDAR_PROVIDER_APPLE_TITLE(),
        subtitle: language.ASA_STANDALONE_CALENDAR_PROVIDER_APPLE_SUBTITLE(),
      },
    }),
    [iconSize, language],
  );

  return { calendarProviderData };
};
